import React from 'react';
import Select from 'react-select';

import { SelectFilter, Filter, SelectOption } from '../FilterTypes';
import { customStyles } from '../form/fields/Select';

interface Props {
    filter: SelectFilter;
    filterChanged: (filter: Filter, event: unknown) => void;
    withIsSelected: boolean;
}

export default class MultiSelectFilterField extends React.Component<Props, Record<string, never>> {
    checkbox(filter: SelectFilter) {
        return (
            <input
                checked={filter.isSelected}
                data-testid={`filter.${filter.name}.enable`}
                name={filter.name + 'Selected'}
                onChange={(e) => this.props.filterChanged(filter, e)}
                style={{ marginBottom: 25 }}
                type="checkbox"
            />
        );
    }

    render() {
        const filter = this.props.filter;
        return (
            <div className="wfp-form--group" key={filter.name}>
                <label htmlFor="selection">{filter.label}:</label>
                {this.props.withIsSelected && this.checkbox(filter)}
                <div className="replaced-form-input" data-testid={`filter.${filter.name}.select`}>
                    <Select
                        className="react-select-container"
                        isMulti={true}
                        name={filter.name}
                        onChange={(e) => this.props.filterChanged(filter, e)}
                        options={this.getOptions(filter)}
                        searchable={false}
                        styles={customStyles}
                        value={filter.value}
                    />
                </div>
            </div>
        );
    }

    private getOptions(filter: SelectFilter) {
        const allSelectOption = new SelectOption('ALL', 'ALL');
        if (filter.options.length > 1) {
            return [allSelectOption, ...filter.options];
        }
        return filter.options;
    }
}
